import React, { useMemo } from 'react'
import { Avatar, Tooltip } from 'components/ui'
import acronym from 'utils/acronym'
import PropTypes from 'prop-types'
import useTwColorByName from 'utils/hooks/useTwColorByName'
import { normalizeUserPhotoUrl } from 'utils/avatarUrl'

const UsersAvatarGroup = (props) => {
    const {
        avatarGroupProps,
        avatarProps,
        imgKey,
        nameKey,
        onAvatarClick,
        users,
        ...rest
    } = props

    const bgColor = useTwColorByName()

    const defaultAvatarProps = useMemo(() => {
        return {
            shape: 'circle',
            size: 30,
            className: 'cursor-pointer',
            ...avatarProps,
        }
    }, [avatarProps])

    const handleAvatarClick = (avatar) => {
        onAvatarClick?.(avatar)
    }

    return (
        <Avatar.Group
            omittedAvatarTooltip
            omittedAvatarProps={defaultAvatarProps}
            chained
            {...avatarGroupProps}
            {...rest}
        >
            {users.map((elm, index) => {
                const name = elm[nameKey] || elm.user_fullname || elm.name || ''
                const avatarSrc = normalizeUserPhotoUrl(elm[imgKey] || elm.user_photo || elm.src)

                return (
                    <Tooltip key={name + index} title={name}>
                        <Avatar
                            {...defaultAvatarProps}
                            className={`${
                                avatarSrc ? '' : bgColor(name)
                            } ${defaultAvatarProps.className}`}
                            src={avatarSrc}
                            onClick={() => handleAvatarClick(elm)}
                        >
                            {acronym(name)}
                        </Avatar>
                    </Tooltip>
                )
            })}
        </Avatar.Group>
    )
}

UsersAvatarGroup.defaultProps = {
    avatarProps: {},
    avatarGroupProps: {},
    users: [],
    nameKey: 'name',
    imgKey: 'img',
}

UsersAvatarGroup.propTypes = {
    users: PropTypes.array,
    avatarProps: PropTypes.object,
    avatarGroupProps: PropTypes.object,
    nameKey: PropTypes.string,
    imgKey: PropTypes.string,
}

export default UsersAvatarGroup
